import { render, staticRenderFns } from "./PrintA4Template.vue?vue&type=template&id=50205dc4&scoped=true&"
import script from "./PrintA4Template.vue?vue&type=script&lang=js&"
export * from "./PrintA4Template.vue?vue&type=script&lang=js&"
import style0 from "./PrintA4Template.vue?vue&type=style&index=0&id=50205dc4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "50205dc4",
  null
  
)

export default component.exports